import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'

interface TagadaPayRouterDescriptorCardProps {
    processor: ProcessorDetails
}

export const TagadaPayRouterDescriptorCard = ({ processor }: TagadaPayRouterDescriptorCardProps) => {
    const { t } = useTranslation('processors')
    const options = processor.options as Record<string, unknown> | null
    const descriptor = options?.statementDescriptor as string | undefined

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('statementDescriptor')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div>
                        <p className="text-sm text-muted-foreground">{t('descriptor')}</p>
                        <p className="font-semibold font-mono">{descriptor || t('notConfigured')}</p>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}
